import React, { useEffect } from "react";
import "./What_Healing_Looks_Like.css";
import Common_Title_2 from "../../common/common_components/common_title_2/Common_Title_2";
import { AllSpandan_Videos } from '../../../features/admin/spandan/Slice';
import { useDispatch, useSelector } from 'react-redux';
import { IDS } from "../../../utils/IDS";

const What_Healing_Looks_Like = () => {

  const dispatch = useDispatch();

  const all_spandan_videos = useSelector(
    (state) => state.spandan.all_spandan_videos
  );

  useEffect(() => {
    dispatch(AllSpandan_Videos());
  }, [dispatch]);



  return (
    <section className="What_Healing_Looks_Like">
      <div className="container">
        <Common_Title_2 subText="What Healing Looks Like" />

        <div className="images_holder">
          <div className="row justify-content-center">

            {all_spandan_videos?.map((item) => {
              return (
                <div className="col-lg-3 col-md-4 col-6 mb-4" key={item.id}>
                  <div className="main_div">
                    <video
                      className="inner_img"
                      src={`${IDS.IMG_URL}${item.video}`}
                      autoPlay
                      loop
                      controls
                      muted
                      playsInline
                    />
                  </div>
                </div>
              );
            })}

          </div>
        </div>
      </div>
    </section>
  );
};

export default What_Healing_Looks_Like;













// import React, { useEffect } from "react";
// import "./What_Healing_Looks_Like.css";
// import Common_Title_2 from "../../common/common_components/common_title_2/Common_Title_2";
// import { AllSpandan_Videos } from '../../../features/admin/spandan/Slice';
// import { useDispatch, useSelector } from 'react-redux';
// const What_Healing_Looks_Like = () => {

//   const dispatch = useDispatch();

//   const all_spandan_videos = useSelector((state) => state.spandan.all_spandan_videos);


//   console.log("all_spandan_videos[0]",all_spandan_videos[1])
//     useEffect(() => {
//     dispatch(AllSpandan_Videos());
//   }, [dispatch]);

//   const data = [
//     "/assets/videos/spandan/what_healing_looks_like/vdo1.mp4",
//     "/assets/videos/spandan/what_healing_looks_like/vdo2.mp4",
//     "/assets/videos/spandan/what_healing_looks_like/vdo3.mp4",
//     "/assets/videos/spandan/what_healing_looks_like/vdo1.mp4",
//   ];

//   return (
//     <section className="What_Healing_Looks_Like">
//       <div className="container">
//         <Common_Title_2 subText="What Healing Looks Like" />

//         <div className="images_holder">
//           <div className="row justify-content-center">
//             {all_spandan_videos?.map((videoSrc, index) => {
//               return (
//                 <div className="col-lg-3 col-md-4 col-6 mb-4" key={index}>
//                   <div className="main_div">
//                     <video
//                       className="inner_img"
//                       src={videoSrc}
//                       autoPlay
//                       loop
//                       muted
//                       playsInline
//                     />
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default What_Healing_Looks_Like;
